module.exports = __webpack_public_path__ + "img/close.4ffd515d.png";